import React, { Component, Fragment } from 'react'

import PropTypes from 'prop-types';

const propType = {
    password: PropTypes.string,
    onPasswordChange: PropTypes.func,
}

export default class InputPassword extends Component {

    onPassChange = (e) => {
        this.props.onPasswordChange(e.target.value);
    }

    render() {
        const { password } = this.props;
        return (
            <Fragment>
                <input className="login-input"
                    type="password"
                    name="pass"
                    placeholder="Password"
                    value={password}
                    onChange={this.onPassChange}
                />
                <span className="login-input-focus"></span>
                <span className="login-input-symbol">
                    <i className="fa fa-lock" aria-hidden="true"></i>
                </span>
            </Fragment>
        );
    }

}

InputPassword.propTypes = propType;